/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.LabelDepartmentInfoResponseDto>
>;
export function request(
  params: API.basics.labelDepartmentInfo.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelDepartmentInfo/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
